import React, { useState, useEffect } from 'react';
import QrReader from 'react-web-qr-reader';
import styles from './ScanQR.module.scss';
import { Row, Modal } from 'antd';
import collabAPI from '~/api/CollabAPI';
import packAPI from '~/api/PackAPI';
import { getNumberWithCommas } from '~/utils';
import FormCanNot from '~/components/FormCanNot';
import queryString from 'query-string';

const ScanQR = () => {
    const delay = 500;

    const previewStyle = {
        // height: 240,
        width: 320,
    };

    const [result, setResult] = useState('');
    const [isShowResultModal, setIsShowResultModal] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [titleResult, setTitleResult] = useState('');
    const [textResult, setTextResult] = useState('');

    const handleScan = async (result) => {
        if (!isShowResultModal) {
            const data = result?.data || '';
            if (data) {
                if (data.includes('pack_id')) {
                    try {
                        const pack_id = data.split('pack_id=').join('');
                        const body = {
                            pack_id,
                        };
                        const res = await packAPI.submitPackAPI(body);

                        setIsShowResultModal(true);
                        setIsSuccess(true);
                        setTitleResult('Deposit successful!');
                        setTextResult(
                            `You have successfully loaded the package ${getNumberWithCommas(
                                res?.results?.object?.pack_info?.value,
                            )} d, incentives ${res?.results?.object?.pack_info?.endow
                            }%. The total amount received is ${getNumberWithCommas(
                                res?.results?.object?.pack_info?.value,
                            )} d.`,
                        );
                    } catch (err) {
                        setIsShowResultModal(true);
                        setIsSuccess(false);
                        setTitleResult('Deposit failed!');
                        setTextResult(err.message);
                    }
                } else {
                    if (data.includes('http')) {
                        setResult(data);
                        if (data.includes('page.link')) {
                            window.location.assign(data);
                            // window.location.replace(data);
                            // const newWindow = window.open(data);
                            // if (newWindow) {
                            //     newWindow.opener = null;
                            // }
                            // const parent_id = localStorage.getItem('user_id') || '';
                            // localStorage.removeItem('user_id');
                            // if (parent_id) {
                            //     try {
                            //         console.log('Khiem parent_id', parent_id);
                            //         const body = {
                            //             parent_id,
                            //         };
                            //         const res = await collabAPI.joinCollabAPI(body);
                            //         console.log('Khiem collab', res);
                            //         setIsShowResultModal(true);
                            //         setIsSuccess(true);
                            // setTitleResult('Success!');
                            //         setTextResult(
                            // `You have successfully loaded the package ${getNumberWithCommas(
                            //                 res?.results?.object?.pack_info?.value,
                            // )} d, offer ${
                            //                 res?.results?.object?.pack_info?.endow
                            // }%. The total amount received is ${getNumberWithCommas(
                            //                 res?.results?.object?.pack_info?.value,
                            // )} d.`,
                            //         );
                            //     } catch (err) {
                            //         console.log('Khiem err', err);
                            //         setIsShowResultModal(true);
                            //         setIsSuccess(false);
                            // setTitleResult('Fail!');
                            //         setTextResult(err.message);
                            //     }
                            // }
                        } else {
                            window.location.assign(data);
                            // window.open(data, '_blank', 'noopener, noreferrer');
                            // setResult(data);
                        }
                    }
                }
            }
        }
    };

    const handleError = (error) => {
        console.log(error);
    };

    const handleJoinCollab = async () => {
        const parent_id = localStorage.getItem('user_id') || '';
        localStorage.removeItem('user_id');
        if (parent_id) {
            try {
                const body = {
                    parent_id,
                };
                const res = await collabAPI.joinCollabAPI(body);

                setIsShowResultModal(true);
                setIsSuccess(true);
                setTitleResult('Success!');
                setTextResult(
                    `You have successfully loaded the package ${getNumberWithCommas(
                        res?.results?.object?.pack_info?.value,
                    )} d, incentives ${res?.results?.object?.pack_info?.endow
                    }%. The total amount received is ${getNumberWithCommas(res?.results?.object?.pack_info?.value)} d.`,
                );
            } catch (err) {
                setIsShowResultModal(true);
                setIsSuccess(false);
                setTitleResult('Failure!');
                setTextResult(err.message);
            }
        }
    };

    useEffect(() => {
        handleJoinCollab();
    }, []);

    return (
        <div className={styles.wrapper}>
            <Row>
                <QrReader delay={delay} style={previewStyle} onError={handleError} onScan={handleScan} />
            </Row>
            {/* <Row className={styles.result}>
                <p
                    onClick={() => {
                        if (result?.includes('http')) {
                            window.open(result, '_blank', 'noopener, noreferrer');
                        }
                    }}
                >
                    {result}
                </p>
            </Row> */}
            {isShowResultModal && (
                <Modal
                    centered
                    visible={isShowResultModal}
                    onCancel={() => setIsShowResultModal(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <FormCanNot
                            onAgree={() => setIsShowResultModal(false)}
                            text={textResult}
                            textAlignStart={false}
                            title={titleResult}
                            btnBottom={true}
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default ScanQR;
